// extracted by mini-css-extract-plugin
export default {"container":"DayViewNavigation_container__K4Kb+","btn":"DayViewNavigation_btn__jiVCZ","disabled":"DayViewNavigation_disabled__2+s00","content":"DayViewNavigation_content__CBXEw"};